import React from 'react'

import ComingSoonContent from '../../components/ComingSoonContent'

const ComingSoon = () => {
  return <ComingSoonContent />
}

export default ComingSoon
